import React from 'react'
import { FormControlLabel, Switch, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledSwitch = styled(Switch)(({ theme }) => ({
    width: '36px',
    height: '20px',
    padding: 0,
    margin: theme.spacing(1),
    borderRadius: '13px',
    transition: 'all 300ms ease 0s !important',
    '& .MuiSwitch-switchBase': {
        padding: 1,
        transition: 'all 300ms ease 0s !important',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
        },
    },
    '& .MuiSwitch-thumb': {
        width: 18,
        height: 18,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13,
        backgroundColor: '#8F959C',
        opacity: 1,
        transition: 'all 300ms ease 0s !important',
    },
    '&.Mui-disabled': {
        transition: 'all 300ms ease 0s !important',
    },
}))

const ToggleSwitch = ({
    onChange,
    value,
    label,
    labelColor = '#000000',
    fontSize = '14px',
    ...rest
}) => {
    return (
        <Box display="flex">
            <Box display="flex" paddingTop="2px">
                <FormControlLabel
                    control={
                        <StyledSwitch
                            checked={value}
                            onChange={onChange}
                            onKeyDown={(e) => {
                                if (rest?.disabled) return;
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    const target = { checked: !value };
                                    onChange && onChange({ target });
                                }
                            }}
                            {...rest}
                        />
                    }
                    label={label}
                    sx={{
                        '& .MuiFormControlLabel-label': {
                            maxWidth: '220px',
                            fontSize: fontSize,
                            color: labelColor,
                        },
                    }}
                />
            </Box>
        </Box>
    )
}

export default ToggleSwitch
